<template>
	<div class="mt-2">
		<template v-if="type == 'search'">
			<search-bar 
				class="mt-2 mb-2" 
				:placeholder="'Search for '+recordName.toLowerCase()+'s...'" 
				:full-width="true"
				v-model="searchTerms"
				v-on:submit="searchMaterials"
				v-on:clearSearch="showRecords = false">
			</search-bar>

			<field v-if="searchTermsHasMultipleWords" 
				label="Match all words"
				col-class="col-auto"
				:params="{type:'boolean'}"
				v-model="searchMatchAllWords">
			</field>
		</template>

		<div class="mb-2">
			<a v-if="!showSupplierField" href="#" v-on:click.prevent="showSupplierField = true" >Filter by Supplier...</a>
		</div>

		<template v-if="type == 'supplier' || (showSupplierField && (type == 'search' || type == 'browse'))">
			<field
				label="Supplier"
				col-class="col-md-2"
				:params="{type:'select',options:supplierOptions}"
				v-on:change="supplierChange"
				v-model="selectedSupplierId">
			</field>
		</template>

		<template v-if="type == 'browse'">
			<nav v-if="breadcrumb.length > 0">
				<ol class="breadcrumb">
					<li class="breadcrumb-item link" v-on:click="upCategory" v-if="selectedCategory">
						<i class="fa fa-arrow-up"></i>
					</li>
					<li class="breadcrumb-item" :class="{active: index == breadcrumb.length - 1}" v-for="(cat,index) in breadcrumb">
						<a v-if="index != breadcrumb.length - 1" href="#" v-on:click="toCat(cat)">{{ cat.name }}</a>
						<span v-else>{{cat.name}}</span>
					</li>
				</ol>
			</nav>

			<div v-if="localSpinner" class="d-flex flex-row align-items-center">
				<i class="fa fa-spinner fa-spin fa-2x"></i>
				<div class="ml-3">Loading Category...</div>
			</div>

			<ul v-if="!showRecords" class="list-group categories-list mb-2">
				<li class="list-group-item" v-for="cat in categories" v-on:click="setCategory(cat)">
					{{ cat.name }}
				</li>
			</ul>
		</template>

		<div v-if="showRecords">

			<h3 v-if="type != 'supplier'">{{selectedCategoryName}}</h3>

			<table-list 
				:fields="mutatedFields"
				:records="mutateRecords(records)"
				:record-name="recordName"
				:sortable="true"
				:has-edit="true"
				:edit-button-text="(isCustomerAssetTemplate) ? 'Select' : 'Add'"
				v-on:edit="selectMaterial"
				:hide-record-count='true'>
			</table-list>
		</div>
	</div>
</template>
<script type="text/javascript">
import TableList from "../TableList"

import SearchBar from "../SearchBar"
import Field from "@/components/Field"

export default {
	components: {
		TableList,
		SearchBar,
		Field
	},
	props: [
		"isLabourAction",  //switches picker over to LabourAction instead of Material resource
		"isCustomerAssetTemplate",   // switches picker over to CustomerAssetTemplate instead of Material
		"type",            // 'browse', 'search', 'supplier'
		"suggestedRecordsAndIds", //array of ids for suggested materials (they'll be pulled in full when it is selected), OR objects of records
		"jobId", //so we can pull job materials list
		"serviceId" //so we can pull service materials list
	],
	data() {
		return {
			selectedCategory: null,
			selectedSupplierId: false,
			categories: [],
			records: [],
			showRecords: false,
			breadcrumb: [],
			matFields: [
				{label: "Description",  key: "description"},
				{label: "Part Number",  key: "part_number"},
				{label: "Category",     key: "parentCategoryName"}
			],
			labourActionFields: [
				{label: "Description",  key: "description"},
				{label: "Category",     key: "parentCategoryName"}
			],
			customerAssetTemplateFields: [
				{label: "Description",  key: "description"},
				{label: "Category",     key: "parentCategoryName"}
			],
			searchTerms: "",
			searchMatchAllWords: false,
			localSpinner: false,
			showSupplierField: false
		}
	},
	watch: {
		type() {
			this.showRecords = false
			this.selectedSupplierId = false

			if (this.type == 'supplier' || this.type == 'browse' || this.type == 'search')
				this.fetchSuppliers()

			if (this.type == 'suggested') {
				this.selectSuggestedCategory()
			}
			else if (this.type == 'browse') {
				this.selectedCategory = false
				this.breadcrumb = []
				this.fetchCategories()
			}

		}
	},
	computed: {
		resourceInclude() {
			return [this.recordCategoryModel]
		},
		tableFields() {
			if (this.isLabourAction)
				return this.labourActionFields
			else if (this.isCustomerAssetTemplate)
				return this.customerAssetTemplateFields

			return this.matFields
		},
		supplierOptions() {
			return this.optionify(this.$store.suppliers, 'name')
		},
		mutatedFields() {
			if (this.isLabourAction) {
				return [
					{label: "Description",key:"description"},
					//{label: "Category", key: "parentCategoryName"}
				]

			} else if (this.serviceId) {
				return [
					{label: "Description",key:"description"},
					{label: "Part Number", key: "part_number"},
					{label: "Supplier PN", key: "supplier_number"},
				]
			}

			return [
				{label: "Description",key:"description"},
				{label: "Part Number", key: "part_number"},
				{label: "Supplier PN", key: "supplier_number"},
				//{label: "Category", key: "parentCategoryName"}
			]
		},
		recordName() {
			if (this.isLabourAction)
				return "Labour Task"
			else if (this.isCustomerAssetTemplate)
				return "Template"

			return "Material"
		},
		recordModel() {
			if (this.isLabourAction)
				return "LabourAction"
			else if (this.isCustomerAssetTemplate)
				return "CustomerAssetTemplate"
			else
				return "Material"
		},
		recordCategoryModel() {
			if (this.isLabourAction)
				return "LabourActionCategory"
			else if (this.isCustomerAssetTemplate)
				return "CustomerAssetTemplateCategory"

			return "MaterialCategory"
		},
		selectedCategoryName() {
			if (this.selectedCategory == "Suggested "+this.recordName+"s")
				return this.selectedCategory

			else if (this.selectedCategory)
				return this.selectedCategory.name

			else
				return this.recordName+"s"
		},
		searchTermsHasMultipleWords() {
			let split = this.searchTerms.split(" ")
			if (split.length > 1)
				return true
			return false
		}
	},
	methods: {
		supplierChange(supplier_id) {
			let vm = this

			if (!supplier_id)
				this.showSupplierField = false

			if (this.type == 'supplier') { //only pull a query if we're search by supplier, otherwise just use it as an additional filter for other parameters, not triggering a pull
				const params = {
					filters: [['supplier_id', supplier_id]],
					include: this.resourceInclude
				}

				this.spinner(true)

				vm.getJSON(this.recordModel+"/get",params).then(response => {
					vm.records = response.data
					vm.showRecords = true
					vm.spinner(false)
				})
			}
			else {
				this.$nextTick(() => {
					if (this.selectedCategory)
						this.fetchRecords()
				})
			}
			
		},
		searchMaterials(terms) {
			let vm = this

			let filters = []

			if (!this.searchMatchAllWords) {
				//split terms
				let splitTerms = terms.split(" ")

				//description can match split terms
				splitTerms.forEach(term => {
					//const operator = (filters.length) ? "or" : "and"

					//only an "or" operator to split exact match of part number
					let operator = "and"
					if (filters.length == 1)
						operator = "or"

					filters.push(['description', term, operator, 'like'])
				})
			}
			else 
				filters.push(["description",terms,"and","like"])

			if (!this.isLabourAction && !this.isCustomerAssetTemplate) {
				filters.push(['part_number',terms,'or','like']) //part number must match full term
				filters.push(["supplier_number",terms,'or','like'])
				filters.push(["manufacturer",terms,'or','like'])
			}

			if (this.selectedSupplierId > 0)
				filters.push(["supplier_id",this.selectedSupplierId])

			let params = {
				filters: filters,
				include: this.resourceInclude
			}

			this.spinner(true)

			vm.getJSON(this.recordModel+"/get",params).then(response => {
				vm.records = response.data

				vm.showRecords = true

				vm.spinner(false)
			})
		},
		selectMaterial(material) {
			this.$emit("select",material)
		},
		mutateRecords(records) {
			let vm = this

			return records.map(record => {

				record.parentCategoryName = ""
				if (vm.recordCategoryModel in record)
					record.parentCategoryName = record[vm.recordCategoryModel].name
				else if ("job_id" in record) {
					record.parentCategoryName = "Project "+vm.recordName+"s"
				}

				return record
			})
		},
		selectSuggestedCategory() {
			this.selectedCategory = "Suggested "+this.recordName+"s"

			this.fetchSuggestedRecords()
			this.showRecords = true
		},
		setCategory(category) {
			this.selectedCategory = category

			this.breadcrumb.push(category)

			if (this.selectedCategory.ChildCategories.length > 0) {
				this.fetchCategories()
				this.showRecords = false
			}
			else {
				this.fetchRecords()
				this.showRecords = true
			}

		},
		//jump to a category above
		toCat(category) {
			this.selectedCategory = category

			//figure out where to splice off the end of the breadcrumb array
			let indexToSplice = this.breadcrumb.map(item => {return item.id}).indexOf(category.id)+1

			this.breadcrumb.splice(indexToSplice)

			if (this.selectedCategory.ChildCategories.length > 0) {
				this.fetchCategories()
				this.showRecords = false
			}
			else {
				this.fetchRecords()
				this.showRecords = true
			}
		},
		upCategory() {
			this.selectedCategory = this.breadcrumb[this.breadcrumb.length-2] //second last element will take us up one level

			this.breadcrumb.pop()
			this.showRecords = false

			this.fetchCategories()
		},
		fetchSuggestedRecords() {
			let vm = this

			let params = {
				filters: [
					['id',this.suggestedRecordsAndIds.filter(item => typeof item != 'object')]
				],
				include: this.resourceInclude
			}

			let suggestedObjects = this.suggestedRecordsAndIds.filter(item => typeof item == 'object')

			this.getJSON(this.recordModel+"/get",params).then(response => {
				if (response.success) {
					vm.records = [
						...response.data,
						...suggestedObjects
					]
				}
			})
		},
		fetchServiceMaterials() {
			let vm = this

			const params = {
				filters: [
					['service_id', this.serviceId]
				],
				include: [
					{
						model: 'ServiceInvoiceObject',
						filters: [
							['type', 'Material']
						]
					}
				]
			}

			this.getJSON('ServiceInvoice/get', params).then(response => {
				if (response.success) {

					// Build materials list
					let records = []

					response.data.forEach(quote => {
						if ('ServiceInvoiceObject' in quote && quote.ServiceInvoiceObject) {

							quote.ServiceInvoiceObject.forEach(quoteObj => {
								try {
									const material = JSON.parse(quoteObj.field_values_json)
									records.push(material)
								} catch {}
							})
						}
					})

					vm.records = records
				}
			})
		},
		fetchRecords() {
			let vm = this

			let filters = [
				["category_id",this.selectedCategory.id]
			]

			if (this.selectedSupplierId > 0)
				filters.push(["supplier_id",this.selectedSupplierId])

			let params = {
				filters,
				include: this.resourceInclude
			}

			this.getJSON(this.recordModel+"/get",params).then(response => {
				vm.records = response.data
			})
		},
		fetchSuppliers() {
			let vm = this

			if (this.$store.suppliers && this.$store.suppliers.length)
				return

			let params = {
				filters: [['is_supplier', 1]]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.$store.suppliers = response.data
			})
		},
		fetchCategories() {
			let vm = this

			let filters

			if (this.selectedCategory) {
				filters = [
					['category_id',this.selectedCategory.id]
				]		
			}
			else {
				filters = [
					["category_id",0]
				]
			}

			vm.categories = false

			let params = {
				filters: filters,
				include: [this.recordCategoryModel]
			}

			this.localSpinner = true

			this.getJSON(this.recordCategoryModel+"/get",params).then(response => {
				vm.categories = response.data

				vm.localSpinner = false
			})
		}
	},
	created() {
		this.fetchCategories()

		if (this.type == 'supplier' || this.type == 'browse' || this.type == 'search')
			this.fetchSuppliers()
		else if (this.type == 'suggested') 
			this.selectSuggestedCategory()
	}
}
</script>

<style type="text/css" scoped>
	
	.list-group-item:hover {
		background-color: #e0e0e0;
		cursor: pointer;
	}

	.count-badge {
		background-color: #2ca2ff;
		border-radius: 50%;
		padding: 5px;
		padding-top: 4px;
		width: 30px;
		height: 30px;
		color: white;
		font-size: 15px;
		font-weight: bold;
		text-align: center;
	}

	.breadcrumb-item.link {
		color: #007bff;
	}

	.breadcrumb-item.link:hover {
		text-decoration: underline;
		cursor: pointer;
	}

</style>